export const SET_INIT_LOADING = 'SET_INIT_LOADING'